/* One-off correction pass. Rockkt fulfils internationally; six pages said
   otherwise. Rather than rewrite six large templates during a live window,
   these swaps run on page load. They are idempotent and will be folded into the
   markup the next time each template is edited, after which this file can go. */
(function () {
  var SWAPS = [
    ['UK, Royal Mail', 'International, posted from the UK'],
    ['We post from the UK through Royal Mail, so the fulfilment side is strongest in the UK. If your programme spans several continents, a platform with warehouses in each region will serve you better today, and we would rather say that than take the money.',
     'We post from the UK and fulfil internationally. Regional warehousing is the one thing the larger platforms have that we do not, so for very high volume sending inside a single distant market they may still suit you better.'],
    ['You are sending across many countries at once and want warehouses on several continents.',
     'You want stock held in warehouses on several continents rather than posted from one place.'],
    ['Your sending is spread across several countries at once. We post from the UK.',
     'You need stock held regionally rather than posted internationally from the UK.'],
    ['Your sending spans several countries at once. We post from the UK.',
     'You need stock held regionally rather than posted internationally from the UK.'],
    ['You are sending in the UK.', 'You want to start small and prove the channel first.'],
    ['We are not the right answer if you need real ink, if you are sending outside the UK, or if you want a person to sit and write your letters.',
     'We are not the right answer if you need real ink, or if you want a person to sit and write your letters.'],
    ['UK, Royal Mail.', 'International, posted from the UK.'],
    ['Rockkt is a UK company and posts through Royal Mail, so the fulfilment side is strongest in the UK.',
     'Rockkt is a UK company, posts through Royal Mail and fulfils internationally.']
  ];
  function walk(node) {
    if (node.nodeType === 3) {
      var t = node.nodeValue, changed = false;
      for (var i = 0; i < SWAPS.length; i++) {
        if (t.indexOf(SWAPS[i][0]) > -1) { t = t.split(SWAPS[i][0]).join(SWAPS[i][1]); changed = true; }
      }
      if (changed) node.nodeValue = t;
      return;
    }
    if (node.nodeType !== 1) return;
    var tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return;
    for (var c = node.firstChild; c; c = c.nextSibling) walk(c);
  }
  function run() { walk(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
